import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../redux/store.ts";
import { userSlice } from "../redux/slices/user.ts";

export const baseQuery = fetchBaseQuery({
  baseUrl: "/",
  prepareHeaders: (headers, options) => {
    const { accessToken } = (options.getState() as RootState)[userSlice.name];
    if (accessToken !== "") {
      headers.set("Authorization", `Bearer ${accessToken}`);
    }
  },
});

export type BaseQueryT = typeof baseQuery;

export const baseQueriesApi = createApi({
  baseQuery,
  tagTypes: [],
  endpoints: () => ({}),
});
